export class NetworkError extends Error {
  public status: number

  constructor(message: string, statusNumber: number) {
    super(message)
    this.status = statusNumber
  }
}
